"use client";

import { styled } from "@mui/material";
import MuiTooltip, { TooltipProps as MuiTooltipProps } from "@mui/material/Tooltip";
import { CustomHelpOutlineIcon } from "../CustomHelpOutlineIcon";

type Props = Omit<MuiTooltipProps, "children"> & {
  children?: MuiTooltipProps["children"];
  iconFontSize?: "inherit" | "large" | "medium" | "small";
};

const StyledSpan = styled("span")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const Tooltip = (props: Props) => (
  <MuiTooltip {...props}>
    {props.children ? (
      props.children
    ) : (
      <StyledSpan>
        <CustomHelpOutlineIcon fontSize={props.iconFontSize} />
      </StyledSpan>
    )}
  </MuiTooltip>
);
